/**
 * Component that displays a thumbnail that fits the width of its container
 */

import { escapeParens } from '../utils/StringUtils'
import styles from './css/LinkAttachmentThumbnail.module.css'

export const LinkAttachmentThumbnail = ({
  thumbnailUrl,
}: {
  thumbnailUrl?: string | null
}): JSX.Element => {
  return (
    <div>
      {thumbnailUrl ? (
        <div
          className={styles.thumbnail}
          style={{ backgroundImage: `url(${escapeParens(thumbnailUrl)})` }}
        />
      ) : (
        <div className={styles.thumbnailPlaceholder} />
      )}
    </div>
  )
}
